import { apiURL } from "../../config";

export async function getAllUnitsList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/unit/list.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getSearchedUnitsList(axiosPrivate, phrase) {
	return axiosPrivate
		.get(`${apiURL}/organization-unit/search.json?phrase=${phrase}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUnitTreeList(axiosPrivate, unitId) {
	return axiosPrivate
		.get(`${apiURL}/organization-unit/${unitId}/tree.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}
